<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "BrandList" });
import * as API from "../../services/api.js";
import { BRAND_STORE, BRAND_HASH } from "../../services/store.js";
import { onDestroy, onMount } from "svelte";
import { get, writable, derived } from "svelte/store";
export let parameters;
const STORE = writable([]);
let unsubscribe;
let isLoading = false;
let previousParams = "";
let previousHash = $BRAND_HASH;
const syncFromGlobalStore = (data) => {
    const BRANDS = get(STORE).map((brand) => {
        const KEY = brand._.key;
        if (!(KEY in data)) {
            return brand;
        }
        return data[KEY];
    });
    STORE.set(BRANDS);
};
const setStore = (brands) => {
    STORE.set(brands);
    isLoading = false;
};
const onParametersChange = (parameters2) => {
    const CURRENT_PARAMS = JSON.stringify(parameters2);
    if (CURRENT_PARAMS === previousParams) {
        return;
    }
    previousParams = CURRENT_PARAMS;
    isLoading = true;
    void API.filterBrands({ ...parameters2 }).then(setStore);
};
$: onParametersChange(parameters);
const onBrandHashChange = (hash) => {
    if (hash === previousHash) {
        return;
    }
    previousHash = $BRAND_HASH;
    isLoading = true;
    void API.filterBrands({ ...parameters }).then(setStore);
};
$: onBrandHashChange($BRAND_HASH);
onMount(() => {
    unsubscribe = BRAND_STORE.subscribe(syncFromGlobalStore);
});
onDestroy(() => {
    if (unsubscribe !== void 0) {
        unsubscribe();
    }
});
export const COUNT = derived(STORE, ($STORE) => $STORE.length);
</script>

{#if isLoading}
    <slot name = 'loading'/>
{:else if Array.isArray($STORE) && $STORE.length > 0}
    <slot brands = { $STORE }>
        <pre>{ JSON.stringify($STORE, null, 4) }</pre>
    </slot>
{:else}
    <slot name = 'empty' />
{/if}